<template>
  <v-main tag="form">
    <AppBar/>
    <v-layout fill-height column>
      <v-container fluid flex-fill>
        <v-form class="form-item" v-model="valid">
          <label class="label">티켓 코드</label>
          <div class="input-group">
            <v-text-field solo flat filled
                          ref="ticketCd"
                          v-model="ticketCd"
                          :rules="ticketCd_rule"
                          required
                          placeholder="티켓 번호를 입력하세요"
            />
          </div>
        </v-form>
      </v-container>
      <v-footer color="transparent" fixed class="content-footer">
        <div class="content-buttons">
          <BlackBtn x-large str="등록하기" :disabled="!valid" @click="ticketCdReg"></BlackBtn>
        </div>
      </v-footer>
    </v-layout>
  </v-main>
</template>
<script>
import store from '@/store'
import {mixinRemote} from "@/mixins";
import BlackBtn from "@/components/btns/BlackBtn";

export default {
  components: {
    BlackBtn
  },
  mixins: [mixinRemote],
  data: () => ({
    valid: false,
    ticketCd: '',
  }),
  computed: {
    ticketCd_rule() {
      return [
        v => !!v || '필수 입력사항입니다.'
      ]
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    ticketCdReg() {
      this.updateUserTicketCd()
    },
    async updateUserTicketCd() {
      await store.dispatch('updateUserTicketCd', this.$_payload(null, {'ticketCd': this.ticketCd}))
          .then(res => {
            if (res.success) {
              this.$root.$children[0].$refs.toast.toastOpen('top', '티켓 등록이 완료되었습니다.')
              this.prevPage()
            } else {
              this.$alert(res.msg)
            }
          })
          .catch(error => {
            console.error(error);
            this.$refs.ticketCd.focus()
          })
          .finally(() => {
          })
    },

  }
}
</script>
